module.exports = __webpack_public_path__ + "img/b_intro_1_cn.f6a47fb.png";